import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Pax } from 'model/pax.interface';
import { DocumentTypes, EnterpriseAbaco, TypesIva } from '../../../../services/billed-resquest/models/data-billed-form.interface';
import { ConceptTypesArca, CurrenciesArca, DocTypesArca, ResponseArca, TypeIvaArca, PaxListFileCreate, Billing_data, ArcaData } from '../../../../services/billed-resquest/models/tax-authorities/argentina/arca.interface';
import { RequestBilledFormService } from '../../../../services/billed-resquest/services/request-billed-form.service';
import { ArcaService } from 'services/billed-resquest/services/tax-authorities/argentina/arca.service';
import { ArcaStrategies } from 'services/billed-resquest/strategies/tax-authorities/argentina/arca.strategy';


@Component({
  selector: 'usb-request-billed-form',
  templateUrl: './request-billed-form.component.html',
  styleUrls: ['./request-billed-form.component.scss'],
  providers: [
              ArcaService,
              ArcaStrategies,
             ]
})
export class RequestBilledFormComponent implements OnInit {

  @Input() items: any;
  @Input() itineraryItems: any;
  @Input() currencyItinerary: any;
  @Input() currencyAgency : any;
  @Input() currencies: any;
  @Input() idAbaco: number;
  @Input() itineraryPaxList: Pax[];
  @Output() payloadRequestBilling = new EventEmitter<any>();


BoardTypes = [
  {
    key: 'breakfast',
    label: 'Con desayuno',
    matches: ['breakfast', 'bb', 'bed & breakfast','bed and breakfast', 'desayuno', 'con desayuno', 'buffet breakfast']
  },
  {
    key: 'no_breakfast',
    label: 'Sin desayuno',
    matches: ['no breakfast', 'nb', 'sin desayuno', 'room only','ROOM ONLY', 'ro', 'solo alojamiento', 'sólo alojamiento']
  },
  {
    key: 'half_board',
    label: 'Media pensión',
    matches: ['half board', 'hb', 'media pensión', 'media pension']
  },
  {
    key: 'full_board',
    label: 'Pensión completa',
    matches: ['full board', 'fb', 'pensión completa', 'pension completa']
  },
  {
    key: 'all_inclusive',
    label: 'Todo incluido',
    matches: ['all inclusive', 'ai', 'todo incluido']
  }
]

  billing_data: Billing_data;

  requestForm: FormGroup;
  formStyles: { backgroundColor: string, pointerEvents: string }[] = [];

  // arca

  typeIva: TypeIvaArca[] = [];
  docTypes: DocTypesArca[] = [];
  originalTypeDoc: DocTypesArca[] = [];
  conceptTypes: ConceptTypesArca[] = [];

  conditionIva: any[] = [];
  enterprises: EnterpriseAbaco[] = [];

  originalConditionIva: any[] = [];
  originalClients: any[] = [];

  clients: any[] = [];
  receiptTypes: any[] = [];
  countriesInvoiceT: any[] = [];
  countries: any[] = [];
  tourismItemCode: any[] = [];


  typesIva: TypesIva[] = [];
  documentTypesBooking: DocumentTypes[] = [];

  clientStateName: string = '';
  clientCityName: string = '';

  payload: any;
  clientCountryCode: any;

  isLoadingReceiptTypes: boolean = true;

  currenciesApi: CurrenciesArca[] = [];
  arcaData: ArcaData;
  isLoading: boolean = false;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
                private formBuilder: FormBuilder,
                private requestBilledService: RequestBilledFormService,
                private userService: UserService,
                private arcaService: ArcaService,
                private arcaStrategies: ArcaStrategies
              ) {}

  async ngOnInit() {
    console.log(this.items)
    this.initRequestForm();
    await this.loadArcaData();

  }

  // Inicialización del formulario
  initRequestForm(): void {
    this.requestForm = this.formBuilder.group({
      request: this.formBuilder.array([this.createRequestForm()])
    });

  this.subscribeChangesForm();

  }

  subscribeChangesForm(): void {
    const requestArray = this.requestForm.get('request') as FormArray;

    // Suscribirse a los cambios en cada control existente
    requestArray.controls.forEach((control, index) => {
      this.subscribeToControlChanges(control, index);
    });

    // Detectar cuando se agrega un nuevo control al FormArray
    requestArray.valueChanges.subscribe({
      next: () => {
        const newIndex = requestArray.controls.length - 1;
        const newControl: any = requestArray.at(newIndex);

        if (!newControl.valueChanges.observed) {
          this.subscribeToControlChanges(newControl, newIndex);
        }
      }
    });
  }

  subscribeToControlChanges(control: AbstractControl, index: number): void {
    control.valueChanges.subscribe({
      next: () => {

        if (control.value.enterprise_id) {
          const enterprise: EnterpriseAbaco = this.enterprises.find(c => c.id === Number(control.value.enterprise_id));

          // Actualizar valores sin disparar el evento `valueChanges`
          control.get('iva_condition_id').setValue(enterprise.iva_condition_id, { emitEvent: false });
          control.get('cuit').setValue(enterprise.cuit_cuilt, { emitEvent: false });
          control.get('address').setValue(enterprise.address, { emitEvent: false });
          control.get('email').setValue(enterprise.email, { emitEvent: false });
        }

        if(control.value.client_id) {
          const client = this.clients.find(c => c.id === Number(control.value.client_id));

          if(client.iva_id) {
            control.get('iva_condition_id').setValue(client.iva_id, { emitEvent: false });
          }
          if(client.cuit) {
            control.get('cuit').setValue(client.cuit, { emitEvent: false });
          }
          // Actualizar valores sin disparar el evento `valueChanges`
          control.get('address').setValue(client.address, { emitEvent: false });
          control.get('email').setValue(client.email, { emitEvent: false });
        }

        this.submitForm();
      }
    });
  }

  changeBillingType(index: number): void {
    const requestArray = this.requestForm.get('request') as FormArray;
    const control = requestArray.at(index);

    // Nullificar los controles asociados al índice
    control.get('client_id').setValue(null, { emitEvent: false });
    control.get('enterprise_id').setValue(null, { emitEvent: false });
    control.get('iva_condition_id').setValue(null, { emitEvent: false });
    control.get('cuit').setValue(null, { emitEvent: false });
    control.get('address').setValue(null, { emitEvent: false });
    control.get('email').setValue(null, { emitEvent: false });

    this.clients = [...this.originalClients];
    this.docTypes = [...this.originalTypeDoc];
    this.conditionIva = [...this.originalConditionIva];

  }

  // Método para crear una nueva instancia de formulario dentro de 'request'
  createRequestForm(): FormGroup {
    return this.formBuilder.group({
      iva_condition_id: new FormControl(null),
      billing_type_id: new FormControl("1"),
      business_name: new FormControl(null),
      client_id: new FormControl(null),
      address: new FormControl(null),
      email: new FormControl(null),
      document_type_id: new FormControl(null),
      cuit: new FormControl(null),
      receipt_type: new FormControl(null),
      enterprise_id: new FormControl(null),
    });
  }

  // Método para agregar un nuevo formulario al array
  addRequest(): void {
    this.requestArray.push(this.createRequestForm());
  }

  // Método para eliminar un formulario por índice
  removeRequest(index: number): void {
    this.requestArray.removeAt(index);
  }

  // Getter para acceder al FormArray
  get requestArray(): FormArray {
    return this.requestForm.get('request') as FormArray;
  }

  // Método para enviar el formulario
  submitForm(): void {
    // Inicializamos el payload
  let payload: any[] = [];

  // Obtenemos el array de formularios del FormArray
  const requests = this.requestArray.value;

  payload.push(
   {
     itinerary_id: this.items[0].itinerary_id,
     product_quantity: this.items.length,
     total_price: this.totalPrice(),
     agent_id: this.userService._agentID,
     agency_id: this.userService._agencyID,
     items_id: this.itemsId(),
     billing_info: [],
   },
  )

  requests.forEach((request: any, index: number) => {

      if(request.enterprise_id) {

        request.iva_condition_id = request.iva_condition_id === 3 ? 5 : request.iva_condition_id;

      }


      payload[0].billing_info.push({
        iva_condition_id: request.iva_condition_id ? Number(request.iva_condition_id): null,
        billing_type_id: request.billing_type_id ? Number(request.billing_type_id) : null,
        client_id: request.client_id ? Number(request.client_id) : null,
        cuit: request.cuit ? request.cuit : null,
        enterprise_id: request.enterprise_id ? Number(request.enterprise_id) : null,
        billed_data: this.setBillingData(request, index)
      });

  })

console.log(payload);

  this.payload = payload;

  if (payload[0].billing_info.every(info => (info.enterprise_id !== null || info.client_id !== null) && info.cuit !== null && info.iva_condition_id !== null && info.billed_data.receip_type !== null))
                                             {
                                                this.payloadRequestBilling.emit(this.payload);
                                             }

  }

  setBillingData(request: any, index: number): any {

      const items =  this.getItems(index);
      const paymentConverted = this.items[0]?.converted_amounts?.netPriceBooking ? this.items[0]?.converted_amounts?.netPriceBooking : this.items[0].netPriceBooking;
      const firstItem = this.items[0];


      if(request.client_id) {
        const requestArray = this.requestForm.get('request') as FormArray;
        const control = requestArray.at(index);
        const client = this.clients.find(c => c.id === Number(request.client_id));
        const ivaConditionId = control.get('iva_condition_id')?.value;
        const receiptTypeId = control.get('receipt_type').value;
        const receipt = this.receiptTypes.find(c => Number(c.Id) === Number(receiptTypeId));
        const receiptName = receipt?.Desc;
        const docTypeId = this.getDocTypesBillingData('client', control.get('receipt_type')?.value, control.get('iva_condition_id')?.value, index, client.document_number);

        return this.billing_data = {
                                      name: `${client.first_name} ${client.last_name}`,
                                      email: client.email,
                                      address: client.address,
                                      phone: client.phone,
                                      doc_type:  docTypeId, // falta acomodar acá
                                      document_type_name: this.docTypes.find(c => Number(c.Id) === Number(docTypeId))?.Desc,
                                      document_number: client.cuit ? client.cuit : control.get('cuit').value,
                                      iva: client.iva,
                                      iva_condition_name: this.conditionIva.find(c => Number(c.Id) === Number(ivaConditionId))?.Desc,
                                      iva_condition_id: control.get('iva_condition_id')?.value,
                                      receipt_type: Number(control.get('receipt_type').value),
                                      receipt_type_name: receiptName,
                                      concept_type: 2,
                                      client_postal_code: client?.postal_code ? client?.postal_code : '000000',
                                      client_city: this.clientCityName,
                                      client_province: this.clientStateName,
                                      client_country: client.country_id,
                                      products: items,
                                      date_registration: new Date(),
                                      passenger: this.getPassengers(false, items),
                                      file_id_abaco: this.idAbaco,
                                      total_iva: this.totalIva(),
                                      total_taxed: this.totalTaxed(),
                                      total_untaxed:this.totalUntaxed(ivaConditionId),
                                      currency: this.getCurrency(index),
                                      currency_code_payment_booking: paymentConverted === firstItem.netPriceBooking ? firstItem?.currency : this.currencyAgency?.code,
                                      same_currency_foreign: this.GetCurrencySameForeign(),
                                      // iva_details: this.getIvaDetails('client', items, control.get('receipt_type')?.value, control.get('iva_condition_id')?.value, index),
                                      client_country_code: this.clientCountryCode ? this.clientCountryCode : null,
                                   }
      }
      if(request.enterprise_id) {
        const requestArray = this.requestForm.get('request') as FormArray;
        const control = requestArray.at(index);
        const enterprise = this.enterprises.find(c => c.id === Number(request.enterprise_id));
        const receiptTypeId = control.get('receipt_type').value;
        const receipt = this.receiptTypes.find(c => Number(c.Id) === Number(receiptTypeId));
        const receiptName = receipt?.Desc;
        const ivaConditionId =  this.getConditionId(enterprise.iva_condition_id, 'id');
        console.log(enterprise)
        return this.billing_data = {
                                      name: enterprise.business_name,
                                      email: enterprise.email,
                                      address: enterprise.address,
                                      phone: enterprise.phone1,
                                      doc_type: this.getDocTypesBillingData('enterprise',control.get('receipt_type')?.value, control.get('iva_condition_id')?.value, index, enterprise.cuit_cuilt),
                                      document_type_name: 'CUIT',
                                      document_number: enterprise.cuit_cuilt,
                                      iva: enterprise.iva,
                                      iva_condition_name: this.getConditionId(enterprise.iva_condition_id, 'name'),
                                      iva_condition_id: this.getConditionId(enterprise.iva_condition_id, 'id'),
                                      receipt_type: Number(control.get('receipt_type').value),
                                      receipt_type_name: receiptName,
                                      concept_type: 2,
                                      client_postal_code: enterprise?.postal_code,
                                      client_city: enterprise.destination_name,
                                      client_province: enterprise.zone_name,
                                      client_country: enterprise.country_code,
                                      products: items,
                                      date_registration: new Date(),
                                      file_id_abaco: this.idAbaco,
                                      total_iva: this.totalIva(),
                                      passenger: this.getPassengers(true, enterprise),
                                      total_taxed: this.totalTaxed(),
                                      currency_code_payment_booking: paymentConverted === firstItem.netPriceBooking ? firstItem?.currency : this.currencyAgency?.code,
                                      currency: this.getCurrency(index),
                                      total_untaxed: this.totalUntaxed(ivaConditionId),
                                   }
      }
  }

    getPassengers(passengerEnterprise: boolean, formData: any): PaxListFileCreate[] {

    const paxList: PaxListFileCreate[] = [];

    if(passengerEnterprise) {

        paxList.push({'full_name': formData.business_name, 'document_type': 'CUIT', 'document_number': formData.cuit_cuilt});

    } else {

        const paxListParsed: Pax[] = this.itineraryPaxList;

        paxListParsed.forEach((pax: Pax) => {

          console.log(this.docTypes);
            const documentType = this.documentTypesBooking.find(c => Number(c.id) === Number(pax.document_type_id));

            if(documentType) {
              paxList.push({'full_name': `${pax.first_name} ${pax.last_name}`, 'document_type': documentType.name, 'document_number': pax.document_number});
            }
        });

    }

    return paxList.length > 0 ? paxList : [];

  }



    getIvaDetails(type: string, items: any, receiptType?: string, ivaCondition?: string, index?: number): any {

    let detail: any;


        if(type === 'client') {
      switch(receiptType) {
        case '6':
          if(ivaCondition === '5') {
            const itemsToUse = items || this.getItems(index);
            return this.groupByIva(itemsToUse);
          }
      }
    }

    return detail;

  }


  // Método para agrupar por alícuota de IVA
groupByIva(items: any[]): any {
  const ivaGroups: { [key: string]: { base: number, iva_amount: number } } = {};

  items.forEach((item: any) => {
    const ivaKey = item.iva.toString(); // Clave de la alícuota (ej: "21")
    const base = item.unit_price;       // Base imponible
    const ivaAmount = item.iva_amount;  // Monto de IVA

    // Si no existe el grupo, lo inicializamos
    if (!ivaGroups[ivaKey]) {
      ivaGroups[ivaKey] = {
        base: 0,
        iva_amount: 0
      };
    }

    // Sumamos al grupo correspondiente
    ivaGroups[ivaKey].base += base;
    ivaGroups[ivaKey].iva_amount += ivaAmount;
  });

  return ivaGroups;
}

  getDocTypesBillingData(type: string, receiptType?: string, ivaCondition?: string, index?: number, documentNumber?: any): number {

    let docType: number = -1;
    if(type === 'enterprise') {
      this.docTypes = [...this.originalTypeDoc];
      console.log(this.docTypes)
       const formGroup = this.requestForm.get(['request', index]) as FormGroup;
            formGroup.patchValue({
              document_type_id: 80,
              cuit: documentNumber
            }, { emitEvent: false });
            docType = 80;

            console.log(formGroup)
    }
    if(type === 'client') {
      switch(receiptType) {
        case '6':
          if(ivaCondition === '5') {
            const formGroup = this.requestForm.get(['request', index]) as FormGroup;
            formGroup.patchValue({
              document_type_id: 99,
              cuit: "0"
            }, { emitEvent: false });
            docType = 99;
          }
          if(ivaCondition === '4') {
            const formGroup = this.requestForm.get(['request', index]) as FormGroup;
                formGroup.patchValue({
                  document_type_id: 99,
                  cuit: documentNumber
                }, { emitEvent: false });
                docType = 99;
          }
          break;
      case '11':
          if(ivaCondition === '1') {
            const formGroup = this.requestForm.get(['request', index]) as FormGroup;
            formGroup.patchValue({
              document_type_id: 99,
              cuit: documentNumber
            }, { emitEvent: false });
            docType = 99;
          }
          if(ivaCondition === '6') {
            const formGroup = this.requestForm.get(['request', index]) as FormGroup;
                formGroup.patchValue({
                  document_type_id: 99,
                  cuit: documentNumber
                }, { emitEvent: false });
                docType = 99;
          }
        if(ivaCondition === '5') {
            const formGroup = this.requestForm.get(['request', index]) as FormGroup;
            formGroup.patchValue({
              document_type_id: 99,
              cuit: "0"
            }, { emitEvent: false });
            docType = 99;
          }
          if(ivaCondition === '4') {
            const formGroup = this.requestForm.get(['request', index]) as FormGroup;
                formGroup.patchValue({
                  document_type_id: 99,
                  cuit: documentNumber
                }, { emitEvent: false });
                docType = 99;
          }
          break;

      case '195':
            // if(ivaCondition === '5' || ivaCondition === '9') {
                const formGroup = this.requestForm.get(['request', index]) as FormGroup;
                formGroup.patchValue({
                  document_type_id: 80,
                  cuit: documentNumber
                }, { emitEvent: false });
                docType = 80;
              // }
              // if(ivaCondition === '1') {
              //   const formGroup = this.requestForm.get(['request', index]) as FormGroup;
              //   formGroup.patchValue({
              //     document_type_id: 80,
              //     cuit: documentNumber
              //   }, { emitEvent: false });
              //   docType = null;
              // }
          break;
      }

    }

    return docType;
  }

  getConditionId(typeId: number, type: string): number | string {
    switch(typeId) {
      case 1:
        return type === 'id' ? 1 : this.conditionIva.find(c => Number(c.Id) === 1)?.Desc;
      case 2:
        return type === 'id' ? 4 : this.conditionIva.find(c => Number(c.Id) === 4)?.Desc;
      case 3:
        return type === 'id' ? 5 : this.conditionIva.find(c => Number(c.Id) === 5)?.Desc;
      case 4:
        return type === 'id' ? 6 : this.conditionIva.find(c => Number(c.Id) === 6)?.Desc;
      case 5:
        return type === 'id' ? 5 : this.conditionIva.find(c => Number(c.Id) === 5)?.Desc;
    }
  }

  itemsId(): any[] {
    const ids: any[] = [];

    this.items.forEach((item: any) => {
      ids.push(item.id);
    })

    return ids;
  }

getCurrency(index: number): string {
  const firstItem = this.items[0];
  const paymentConverted = this.items[0].converted_amounts?.netPriceBooking;

  if (paymentConverted === firstItem.netPriceBooking) {
    return 'DOL';
  }

  // Mapeo de códigos a descripciones
  const currencyMap: { [key: string]: string } = {
    'ARS': 'Pesos Argentinos',
    'USD': 'Dólar Estadounidense',
    'BRL': 'Real',
    'CLP': 'Peso Chileno',
    'COP': 'Peso Colombiano',
    'MXN': 'Pesos Mejicanos',
    'PEN': 'Nuevo Sol Peruano',
    'UYU': 'Pesos Uruguayos',
    'EUR': 'Euro',
    'GBP': 'Libra Esterlina',
    'JPY': 'Yens',
    'CHF': 'Franco Suizo'
  };

  const targetDescription = currencyMap[this.currencyAgency?.code];

  if (targetDescription) {
    const currency: CurrenciesArca = this.currenciesApi.find(c =>
      c.Desc.toLowerCase().includes(targetDescription.toLowerCase())
    );
    return currency?.Id || 'DOL';
  }

  return 'DOL'; // Default
}

GetCurrencySameForeign(): boolean {
  const firstItem = this.items[0];
  const paymentConverted = this.items[0].converted_amounts?.netPriceBooking;

  if (paymentConverted === firstItem.netPriceBooking) {
   return true;
  } else {
      // Mapeo de códigos a descripciones
    return false;

  }
}

    getItems(index: number): any[] {
      const itemsArr: any[] = [];

      const requestArray = this.requestForm.get('request') as FormArray;
      const control = requestArray.at(index);

      const receiptType = control.get('receipt_type').value;

      this.items.forEach((item: any) => {

        // Calcular valores una vez
        const hasConverted = !!item?.converted_amounts;
        const unitPrice = hasConverted
          ? this.getPriceBookingFreeTax(item.converted_amounts)
          : item.netPriceBookingFreeTax;

        const iva_amount = hasConverted
          ? item.converted_amounts.taxPrice
          : item.taxNightsPriceTotal;

        const total = hasConverted
          ? (item.feePayment ? item.converted_amounts.netPriceAgent : item.converted_amounts.netPriceBooking)
          : (item.feePayment ? item.netPriceAgent : item.netPriceBooking);

          if(receiptType === '195') {
            itemsArr.push({
              "type": 0,// tipo de item para factura t
              "tourism_code": this.tourismCode(item),// codigo de turismo
              "code": item.title, // codigo
              "description": item?.categoryName ? `Servicio de ${item.categoryName}` : "Servicio de turismo",
              "quantity": 1,
              "unit_price":  unitPrice,
              "vat":  iva_amount === 0 ? 0 : this.getIvaAmountItems(iva_amount, unitPrice, total),
              "base": unitPrice,
              "iva_amount": iva_amount,
              "total": total,
              "file_product_id": item.id
            });

          } else {
            itemsArr.push({
              file_product_id: item?.idAbaco ?? 1,
              description: item?.categoryName ? `Servicio de ${item.categoryName}` : "Servicio de turismo", // ¡Mejorado!
              quantity: 1,
              unit_price: unitPrice,
              iva: iva_amount === 0 ? 0 : this.getIvaAmountItems(iva_amount, unitPrice, total),
              iva_amount: iva_amount,
              total: total,
              unit: "UN",
              state: true,
            });
          }

      });

      return itemsArr;
    }

    getPriceBookingFreeTax(convertedAmounts): number {
      if(convertedAmounts.taxPrice > 0) {
          if(convertedAmounts.netPriceBooking > convertedAmounts.netPriceBookingFreeTax) {
            return convertedAmounts.netPriceBooking - convertedAmounts.taxPrice;
          }
      } else {
        return convertedAmounts.netPriceBooking;
      }
    }

getIvaAmountItems(ivaAmount: number, unitPrice: number, total: number): string {
    if (!ivaAmount || ivaAmount === 0) {
        return '0';
    }

    const base = unitPrice > 0 ? unitPrice : total - ivaAmount;

    if (base <= 0) {
        return '21';
    }

    const calculatedPercentage = (ivaAmount / base) * 100;

    // Redondear al entero más cercano
    const roundedPercentage = Math.round(calculatedPercentage);

    const ivaValues = this.getIvaValuesFromTypes();

    // Si el valor redondeado existe en la lista, usarlo; si no, usar 21
    return ivaValues.includes(roundedPercentage) ? roundedPercentage.toString() : '21';
}

private getIvaValuesFromTypes(): number[] {
    if (!this.typeIva || this.typeIva.length === 0) {
        return [0, 2.5, 5, 10.5, 21, 27];
    }

    return this.typeIva.map((ivaType: TypeIvaArca) => {
      console.log(ivaType);
        const cleanString = ivaType.Desc.replace('%', '').trim();
        return parseFloat(cleanString);
    }).filter(value => !isNaN(value));
}

// private extractPercentageValue(percentageString: string): number {
//   console.log(percentageString)
//     // Remover el símbolo % y cualquier espacio, luego convertir a número
//     const cleanString = percentageString.replace('%', '').trim();
//     return parseFloat(cleanString) || 0;
// }

    tourismCode(item: any): number {

      if(this.tourismItemCode && this.tourismItemCode.length === 0) {
        console.error('No están los código de item de turismo');
        return;
      }

      if(item.categoryName === 'HOTELS') {

            const boardName = item.boardName?.toLowerCase().trim();

            if (!boardName) {
              return 2; // Default sin desayuno si no hay boardName
            }

            // Buscar coincidencia en los tipos de régimen
            const boardType = this.BoardTypes.find(board =>
              board.matches.some(match =>
                boardName.includes(match.toLowerCase())
              )
            );


            // Retornar 1 para con desayuno, 2 para sin desayuno
            switch (boardType?.key) {
              case 'breakfast':
              case 'half_board':
              case 'full_board':
              case 'all_inclusive':
                return 2; // Con desayuno

              case 'no_breakfast':
              default:
                return 1; // Sin desayuno
            }
      } else {
        return 5;
      }

    }

    totalTaxed(): number {
    let total: number = this.items.reduce((sum, item) => {
      const baseUsd = this.currencies.find(c => c.code === item.currency);

      if(!baseUsd) {
        return;
      }

      const feePayment = item.feePayment;
      let itemPrice: number = 0;

      if(item.converted_amounts) {
        if(feePayment) {
          itemPrice = item.converted_amounts.netPriceBookingFreeTax + item.converted_amounts.fee;
        } else {

          if(item.converted_amounts.taxPrice > 0) {
            if(item.converted_amounts.netPriceBooking > item.converted_amounts.netPriceBookingFreeTax) {
              itemPrice = item.converted_amounts.netPriceBooking - item.converted_amounts.taxPrice
            } else {
              itemPrice = item.converted_amounts.netPriceBookingFreeTax;
            }
          } else {
            itemPrice = 0;
          }
        }
      } else {

        if(item.taxNightsPriceTotal > 0) {
          itemPrice = item.netPriceBookingFreeTax;
        } else {
          itemPrice = 0;
        }
      }

      return sum + (itemPrice || 0); // Suma el valor si existe, o usa 0 si no está definido
    }, 0);

    return total;
  }

  totalPrice(): number {
    let total: number = this.items.reduce((sum, item) => {
      const baseUsd = this.currencies.find(c => c.code === item.currency);

      if(!baseUsd) {
        return;
      }

      const feePayment = item.feePayment;
      let itemPrice: number = 0;

      if(item.converted_amounts) {
        if(feePayment) {
          itemPrice = item.converted_amounts.netPriceAgent;
        } else {
          itemPrice = item.converted_amounts.netPriceBooking;
        }
      } else {
        itemPrice = item.netPriceBooking;
      }

      return sum + (itemPrice || 0); // Suma el valor si existe, o usa 0 si no está definido
    }, 0);

    return total;
  }

  totalIva(): number {
        let total: number = this.items.reduce((sum, item) => {
      const baseUsd = this.currencies.find(c => c.code === item.currency);

      if(!baseUsd) {
        return;
      }

      let itemIva: number = 0;

      if(item.converted_amounts) {
        itemIva = item.converted_amounts.taxPrice;
      } else {
        itemIva = item.taxNightsPriceTotal;
      }

      return sum + (itemIva || 0); // Suma el valor si existe, o usa 0 si no está definido
    }, 0);

    return total;
  }

  totalUntaxed(ivaConditionId: any): number {
        let total: number = this.items.reduce((sum, item) => {
      const baseUsd = this.currencies.find(c => c.code === item.currency);

      if(!baseUsd) {
        return;
      }

      let itemPrice: number = 0;

      if(item.converted_amounts) {
        if(ivaConditionId === '5') {
            if(item.converted_amounts.taxPrice === 0) {
              itemPrice = item.converted_amounts.netPriceBooking;
            } else {
              itemPrice = 0;
            }
        } else {
          itemPrice = item.converted_amounts.taxPrice === 0 ? item.converted_amounts.netPriceBooking : this.getPriceBookingFreeTax(item.converted_amounts);
        }

      } else {
        if(ivaConditionId === '5') {
          if(item.taxNightsPriceTotal === 0) {
            itemPrice = item.netPriceBooking;
          } else {
            itemPrice = 0;
          }
        } else {
          itemPrice = item.taxNightsPriceTotal === 0 ? item.taxNightsPriceTotal : (item.netPriceBooking - item.taxNightsPriceTotal);
        }
      }

      return sum + (itemPrice || 0); // Suma el valor si existe, o usa 0 si no está definido
    }, 0);

    return total;
  }

  getStyles(i: number, controlInput?: string) {

    const control = this.requestForm.get(['request', i]);

    if(control?.get('billing_type_id')?.value == 1) {
      const clientId = control?.get('client_id')?.value;
      const ivaConditionClient = control?.get('iva_condition_id')?.value;
      const cuitClient = control?.get('cuit')?.value;
      const receiptType = control?.get('receipt_type')?.value;
      const docType = control?.get('document_type_id')?.value;

      if ( clientId > 0 ) {
        if(controlInput === 'iva_condition_id') {
          return {
            'background-color': '',
            'pointer-events': '',
          };
        }
        if(!cuitClient && controlInput === 'cuit' && ivaConditionClient === '1' && receiptType === '5') {

          return {
            'background-color': '',
            'pointer-events': '',
          };
        }

        if(!docType && controlInput === 'document_type_id' && ivaConditionClient === '1' && receiptType === '5') {

          return {
            'background-color': '',
            'pointer-events': '',
          };
        }

        if(controlInput === 'cuit' && ivaConditionClient === '4' && receiptType === '6') {

          return {
            'background-color': '',
            'pointer-events': '',
          };
        }

        if(controlInput === 'document_type_id' && ivaConditionClient === '4' && receiptType === '6') {

          return {
            'background-color': '',
            'pointer-events': '',
          };
        }

        if(controlInput === 'cuit' && ivaConditionClient === '5' && receiptType === '11') {

          return {
            'background-color': '',
            'pointer-events': '',
          };
        }

        if(controlInput === 'document_type_id' && ivaConditionClient === '5' && receiptType === '11') {

          return {
            'background-color': '',
            'pointer-events': '',
          };
        }

      if(cuitClient && controlInput === 'cuit' && ivaConditionClient && ivaConditionClient === '1' && receiptType === '195') {
          return {
            'background-color': '',
            'pointer-events': '',
          };
        }
      if(!docType && controlInput === 'document_type_id' && ivaConditionClient && ivaConditionClient === '1' && receiptType === '195') {
        return {
            'background-color': '',
            'pointer-events': '',
          };
      }
      } else {

        return {
          'background-color':'#e9ecef',
          'pointer-events': 'none',
          ...this.formStyles[i]
        };
      }
    } else {
      const ivaConditionClient = control?.get('iva_condition_id')?.value;

       if(controlInput === 'iva_condition_id') {
          return {
            'background-color': '',
            'pointer-events': '',
          };
        }

      return {
        'background-color':'#e9ecef',
        'pointer-events': 'none',
        ...this.formStyles[i]
     };
    }

    return {
      'background-color':'#e9ecef',
      'pointer-events': 'none',
      ...this.formStyles[i]
    };
  }

   async loadArcaData() {
    this.isLoading = true;

    try {
      // Opción 1: Cargar todos los datos
      this.arcaData = await this.arcaService.initializeArcaData();

      // Opción 2: Verificar si ya está cargado
      if (!this.arcaService.isDataInitialized()) {
        this.arcaData = await this.arcaService.initializeArcaData();
      } else {
        this.arcaData = this.arcaService.getArcaData();
      }

      console.log('ARCA data loaded:', this.arcaData);

      if(this.arcaData) {

        if(this.arcaData.clients && this.arcaData.clients.data) {
          this.clients = this.arcaData.clients.data;

          console.log(this.clients)
          this.originalClients = [...this.clients];
        }

        if(this.arcaData.ivaTypes && this.arcaData.ivaTypes.length > 0) {
          const typeIva: TypeIvaArca[] = this.arcaData.ivaTypes;
          this.typeIva = typeIva;
        }

        if(this.arcaData.receiverIVAConditions && this.arcaData.receiverIVAConditions.length > 0) {
            this.arcaData.receiverIVAConditions = this.arcaData.receiverIVAConditions.filter(c => c.Id === 1 ||
                                                                                                  c.Id === 4 ||
                                                                                                  c.Id === 5 ||
                                                                                                  c.Id === 6
                                                                                            )
            const conditionIva = this.arcaData.receiverIVAConditions;
            this.conditionIva = conditionIva;
            this.originalConditionIva = [...this.conditionIva]
        }

        if(this.arcaData.bookingDocumentTypes && this.arcaData.bookingDocumentTypes.length > 0) {
          this.documentTypesBooking = this.arcaData.bookingDocumentTypes;
        }

        if(this.arcaData.documentTypes && this.arcaData.documentTypes.length > 0) {

          this.docTypes = this.arcaData.documentTypes;
          this.docTypes = this.docTypes.filter(c => Number(c.Id) === 80 ||
                                                    Number(c.Id) === 86 ||
                                                    Number(c.Id) === 89 ||
                                                    Number(c.Id) === 90 ||
                                                    Number(c.Id) === 94 ||
                                                    Number(c.Id) === 99
                                              );
          this.originalTypeDoc = [...this.docTypes];

        }

        if(this.arcaData.receiptTypes && this.arcaData.receiptTypes.length > 0) {
              let receiptType = this.arcaData.receiptTypes;
              receiptType = receiptType.filter(c => c.Id === 1 || c.Id === 6 || c.Id === 11
              )
              this.receiptTypes = receiptType;

              if(this.getReceiptTypeTourism()) {
                this.receiptTypes[3] = {Id: 195, Desc: 'Factura T'};
              }
              this.isLoadingReceiptTypes = false;
        }

        if(this.arcaData.conceptTypes && this.arcaData.conceptTypes.length > 0) {
          const conceptTypes: ConceptTypesArca[] = this.arcaData.conceptTypes;
          this.conceptTypes = conceptTypes;
        }

        if(this.arcaData.enterprises && this.arcaData.enterprises.length > 0) {
            this.enterprises = this.arcaData.enterprises;
        }

        if(this.arcaData.currencies && this.arcaData.currencies.length > 0) {
          const currenciesApi: CurrenciesArca[] = this.arcaData.currencies;
          this.currenciesApi = currenciesApi;
        }

        if(this.arcaData.tourismItems && this.arcaData.tourismItems.length > 0) {
            if(this.arcaData.tourismItems &&
                  this.arcaData.tourismItems.codigos_item_turismo &&
                  this.arcaData.tourismItems.codigos_item_turismo.consultarCodigosItemTurismoReturn &&
                  this.arcaData.tourismItems.codigos_item_turismo.consultarCodigosItemTurismoReturn.arrayCodigosItem &&
                  this.arcaData.tourismItems.codigos_item_turismo.consultarCodigosItemTurismoReturn.arrayCodigosItem.codigoDescripcion &&
                  this.arcaData.tourismItems.codigos_item_turismo.consultarCodigosItemTurismoReturn.arrayCodigosItem.codigoDescripcion.length > 0
            ) {
              this.tourismItemCode = this.arcaData.tourismItems.codigos_item_turismo.consultarCodigosItemTurismoReturn.arrayCodigosItem.codigoDescripcion;
            }
        }

        if(this.arcaData.countries && this.arcaData.countries.Countrys && this.arcaData.countries.Countrys.length > 0) {
          this.countries = this.arcaData.countries.Countrys;
        }

        if(this.arcaData.ivaConditions && this.arcaData.ivaConditions.length > 0) {
          const typesIva: TypesIva[] = this.arcaData.ivaConditions;
          this.typesIva = typesIva;
        }
      }

    } catch (error) {
      console.error('Error loading ARCA data:', error);
    } finally {
      this.isLoading = false;
    }
  }

  getReceiptTypeTourism(): boolean {

    const itemsHotel = this.items.filter(c => c.category_id === 1);

    const itemsEveryTax = this.items.every(c => c.netPriceBooking !== c.netPriceBookingFreeTax);

    const clientsInternational = this.clients.some(c => c.country_id !== 'AR');

    return itemsHotel.length > 0 && itemsEveryTax && clientsInternational;
  }

  async processInvoice() {
    try {
      const result = await this.arcaStrategies.processBilled({
        // tus metadatos aquí
      });

      if (result.success) {
        console.log('Invoice processed successfully');
      } else {
        console.error('Invoice processing failed:', result.error);
      }
    } catch (error) {
      console.error('Error processing invoice:', error);
    }
  }

  getSpecificCatalog(catalogName: string) {
    return this.arcaData[catalogName] || [];
  }

    getCountriesInvoiceT(): void {

    if(this.countriesInvoiceT && this.countriesInvoiceT.length === 0) {
      this.requestBilledService.countriesInvoiceT().subscribe({
        next: (res: any) => {
          if(res && res?.data && res.data?.paises && res.data.paises?.codigoDescripcionString && res.data.paises.codigoDescripcionString.length > 0) {
            this.countriesInvoiceT = res.data.paises.codigoDescripcionString;
            console.log(this.countriesInvoiceT)
            console.log(this.countries)
          }
        },
        error: (error: HttpErrorResponse) => {
          console.log(error);
        }
      });
    }


  }


  getReceiptTypesArr(receiptType: any): any[] {

    if(this.receiptTypes && this.receiptTypes.length === 0) {
      return [];
    }
    let arr: any[] = [];

    switch(receiptType) {
      case '1':
         arr.push(this.receiptTypes[1]);
         arr.push(this.receiptTypes[2]);
             if(this.getReceiptTypeTourism()) {
               arr.push(this.receiptTypes[3]);
             }
        break;
      case '2':
        arr.push(this.receiptTypes[0]);
        break;
    }

    return arr;
  }


  changeReceiptTypes(index: number): void {

    const receiptType = this.requestForm.get(['request', index, 'receipt_type'])?.value;

    this.clients = [...this.originalClients];
    this.docTypes = [...this.originalTypeDoc];
    this.conditionIva = [...this.originalConditionIva];

    if(!receiptType) {
      return;
    }

    if(this.requestForm.get(['request', index, 'billing_type_id'])?.value === '1') {

      if(this.requestForm.get(['request', index, 'client_id'])?.value) {
        this.requestForm.get(['request', index, 'client_id'])?.setValue(null);
      }

      if(this.requestForm.get(['request', index, 'document_type_id'])?.value) {
        this.requestForm.get(['request', index, 'document_type_id'])?.setValue(null);
      }

      if((this.requestForm.get(['request', index, 'iva_condition_id'])?.value)) {
        this.requestForm.get(['request', index, 'iva_condition_id'])?.setValue(null);
      }

      if((this.requestForm.get(['request', index, 'cuit'])?.value)) {
        this.requestForm.get(['request', index, 'cuit'])?.setValue(null);
      }

      if(receiptType === '6' || receiptType === '11') {
        this.docTypes = this.docTypes.filter(c => Number(c.Id) === 99 ||
                                                  Number(c.Id) === 86 ||
                                                  Number(c.Id) === 89 ||
                                                  Number(c.Id) === 96
                                              );

          if(receiptType === '6') {
        this.conditionIva = this.conditionIva.filter(c => c.Id === 4 ||
                                                          c.Id === 5 ||
                                                          c.Id === 7 ||
                                                          c.Id === 8 ||
                                                          c.Id === 9 ||
                                                          c.Id === 10 ||
                                                          c.Id === 15
                                                    );

          }


      }

      if(receiptType === '195') {
        this.getCountriesInvoiceT();
        this.clients = this.clients.filter(c => c.country_id !== 'AR' && c.country_id !== null);
        this.docTypes = this.docTypes.filter(c => Number(c.Id) === 94);

        this.conditionIva = this.conditionIva.filter(c => c.Id === 1 ||
                                                          c.Id === 5 ||
                                                          c.Id === 9
                                                    );
         }

    } else {

      if(this.requestForm.get(['request', index, 'enterprise_id'])?.value) {
        this.requestForm.get(['request', index, 'enterprise_id'])?.setValue(null);
      }

      if((this.requestForm.get(['request', index, 'iva_condition_id'])?.value)) {
        this.requestForm.get(['request', index, 'iva_condition_id'])?.setValue(null);
      }

      if(this.requestForm.get(['request', index, 'document_type_id'])?.value) {
        this.requestForm.get(['request', index, 'document_type_id'])?.setValue(null);
      }

      if((this.requestForm.get(['request', index, 'cuit'])?.value)) {
        this.requestForm.get(['request', index, 'cuit'])?.setValue(null);
      }

      if(receiptType === '1') {
         this.conditionIva = this.conditionIva.filter(c => c.Id === 1 ||
                                                           c.Id === 6
                                                    );
                                                    console.log(this.conditionIva)
      }
    }

  }

  getTypeDocForm(id: string, index: number): void {

    if(id === '89' || id === '94' || id === '96') {
      const client = this.clients.find(c => Number(c.id) === Number(this.requestForm.get(['request', index, 'client_id'])?.value));

      if(client) {
        this.requestForm.get(['request', index, 'cuit']).setValue(client.document_number);
      }
    }

    if(id === '80' || id === '86') {
        const client = this.clients.find(c => Number(c.id) === Number(this.requestForm.get(['request', index, 'client_id'])?.value));

      if(client) {
        this.requestForm.get(['request', index, 'cuit']).setValue(client.cuit);
      }
    }

  }

 async clientSelected(id: any, index: number) {

    const billingTypeId = this.requestForm.get(['request', index, 'billing_type_id'])?.value;
    const receiptType = this.requestForm.get(['request', index, 'receipt_type'])?.value;
    this.clientStateName = '';
    this.clientCityName = '';

    if(billingTypeId === '1') {
      const client = this.clients.find(c => Number(c.id) === Number(id));
      console.log(client)
      if(receiptType === '195') {

      if(client) {

        let countryInvoiceT: any;
        const country = this.countries.find(c => c.country_code === client.country_id);

        if(country) {
          countryInvoiceT = this.countriesInvoiceT.find(c => c.descripcion.toLowerCase() === country.country_name.toLowerCase());

          if(!countryInvoiceT) {
            countryInvoiceT = this.countriesInvoiceT.find(c => c.descripcion.toLowerCase() === 'resto continente');

          }
          console.log(countryInvoiceT)
          if(countryInvoiceT) {
            this.clientCountryCode = countryInvoiceT?.codigo;
            this.submitForm();
          }
        }

      }


      } else {

      const destination = await this.getDestination(client.country_id, client.state_id);
      const city = await this.getCity(client.state_id, Number(client.city));

        if(destination && city) {
          this.clientStateName = destination.destination_name;
          this.clientCityName = city.city_name;
          this.submitForm();
        }

        if(client) {

        }

      }

    } else {

    }
  }

// Convertir getDestination a Promise
getDestination(country: string, stateId: number): Promise<any> {
  return new Promise((resolve, reject) => {
    this.requestBilledService.getDestinationsApi(country)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (res: any) => {
          if(res && res.destinations && res.destinations.length > 0) {
            const destination = res.destinations.find((c: any) => c.destination_id === stateId);
            resolve(destination);
          } else {
            resolve(null);
          }
        },
        error: (error: HttpErrorResponse) => {
          console.log(error);
          reject(error);
        }
      });
  });
}

// Convertir getCity a Promise
getCity(stateId: any, cityId: number): Promise<any> {
  return new Promise((resolve, reject) => {
    this.requestBilledService.getCitiesApi(stateId)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (res: any) => {
          if(res && res.cities && res.cities.length > 0) {
            const city = res.cities.find((c: any) => c.city_id === cityId);
            resolve(city);
          } else {
            resolve(null);
          }
        },
        error: (error: HttpErrorResponse) => {
          console.log(error);
          reject(error);
        }
      });
  });
}


selectedIvaCondition(ivaConditionId: any, index: number): void {
  console.log(ivaConditionId)

    const receiptType = this.requestForm.get(['request', index, 'receipt_type'])?.value;

    this.docTypes = [...this.originalTypeDoc];

console.log(receiptType)

if(ivaConditionId === '1') {
  if(receiptType === '6') {
    if(ivaConditionId === '4') {

       this.docTypes = this.docTypes.filter(c => Number(c.Id) === 80);

    }
  }
  if(receiptType === '11') {
    if(ivaConditionId === '1') {

       this.docTypes = this.docTypes.filter(c => Number(c.Id) === 80 || Number(c.Id) === 99);

    }
    if(ivaConditionId === '4') {

       this.docTypes = this.docTypes.filter(c => Number(c.Id) === 80 || Number(c.Id) === 99);

    }
    if(ivaConditionId === '5') {

       this.docTypes = this.docTypes.filter(c => Number(c.Id) === 80 || Number(c.Id) === 99);

    }
    if(ivaConditionId === '6') {

       this.docTypes = this.docTypes.filter(c => Number(c.Id) === 80 || Number(c.Id) === 99);

    }
  }

   if(receiptType === '195') {
    //  if(ivaConditionId === '5') {

       this.docTypes = this.docTypes.filter(c => Number(c.Id) === 80);

    // }
  }

} else {
  console.log('aca')
  this.docTypes = this.docTypes.filter(c => Number(c.Id) === 80);
}
}


}
